import React from 'react';

/**
 * NivaAvatar — consistent persona icon for Niva across the app.
 *
 * Renders as a gradient circle with a styled "N" initial, giving Niva
 * a profile-picture feel rather than a generic AI icon.
 *
 * Props:
 *   size  — 'xs' | 'sm' | 'md' | 'lg'  (default: 'sm')
 *   className — extra classes for the outer wrapper
 */
const SIZE_MAP = {
  xs: { outer: 'h-5 w-5',   text: 'text-[9px]',  rounded: 'rounded-md' },
  sm: { outer: 'h-6 w-6',   text: 'text-[10px]', rounded: 'rounded-lg' },
  md: { outer: 'h-9 w-9',   text: 'text-sm',     rounded: 'rounded-xl' },
  lg: { outer: 'h-12 w-12 sm:h-14 sm:w-14', text: 'text-xl sm:text-2xl', rounded: 'rounded-2xl' },
};

const NivaAvatar = ({ size = 'sm', className = '' }) => {
  const { outer, text, rounded } = SIZE_MAP[size] || SIZE_MAP.sm;
  return (
    <div
      className={`${outer} ${rounded} bg-gradient-to-br from-cyan-500 to-blue-600 flex items-center justify-center flex-shrink-0 shadow-sm ${className}`}
      aria-label="Niva"
    >
      <span className={`${text} font-bold text-white leading-none select-none`}>N</span>
    </div>
  );
};

export default NivaAvatar;
